import React from 'react';

import { TabsList, TabsTrigger } from '@/components/ui/tabs';
import { TABS_CONFIG } from '../../constants';

const Header = () => (
  <div className="flex items-center justify-between p-3 border-b">
    <h1 className="text-xl font-semibold">Messenger</h1>

    <TabsList>
      {TABS_CONFIG.map(({ label, value }) => (
        <TabsTrigger key={value} value={value}>
          {label}
        </TabsTrigger>
      ))}
    </TabsList>
  </div>
);

export default Header;
